import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const OrgAdminRedirect = withLazyComponent(
  lazy(async () => ({
    default: (await import('./OrgAdminRedirect')).OrgAdminRedirect,
  }))
);
